module.exports = __webpack_public_path__ + "img/jia.03437177.png";